module.exports = __webpack_public_path__ + "static/d14-dadbdb2c1761f5e6cad75cfb69260a3f.png";